import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function UnsubscribePage() {
  const [params] = useSearchParams();
  const email = params.get("email") || "";
  const token = params.get("token") || "";
  const [status, setStatus] = useState("confirm"); // confirm | done | error | loading
  const [msg, setMsg] = useState("");

  useEffect(() => {
    if (!email || !token) { setStatus("error"); setMsg("رابط غير صالح"); }
  }, [email, token]);

  const unsub = async () => {
    setStatus("loading");
    try {
      await api.post("/unsubscribe", { email, token });
      setStatus("done");
    } catch (e) {
      setStatus("error");
      setMsg(e?.response?.data?.detail || "حدث خطأ");
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-4 sm:p-6">
      <div className="max-w-md sm:max-w-lg w-full space-y-5 bg-card p-6 sm:p-10 rounded-2xl border shadow-sm text-center">
        {status === "confirm" && (
          <>
            <h1 className="text-xl sm:text-2xl font-display font-semibold">إلغاء الاشتراك</h1>
            <p className="text-muted-foreground">هل تريد إيقاف استلام الرسائل التسويقية على <strong>{email}</strong>؟</p>
            <div className="flex gap-2 justify-center pt-2">
              <Button onClick={unsub} data-testid="btn-confirm-unsub">نعم، ألغِ الاشتراك</Button>
              <Button variant="outline" onClick={() => history.back()}>عودة</Button>
            </div>
            <p className="text-xs text-muted-foreground pt-4">سيتم الاحتفاظ بحسابك، لكن لن تصلك رسائل التسويق أو التذكير.</p>
          </>
        )}
        {status === "loading" && <Loader2 className="h-8 w-8 animate-spin mx-auto text-primary" />}
        {status === "done" && (
          <>
            <div className="h-16 w-16 rounded-full bg-primary/10 text-primary grid place-items-center mx-auto">
              <CheckCircle2 className="h-8 w-8" />
            </div>
            <h1 className="text-xl sm:text-2xl font-display font-semibold">تم إلغاء الاشتراك</h1>
            <p className="text-muted-foreground">لن تصلك رسائل تسويقية بعد الآن. رسائل الحساب المهمة (تفعيل، دفع، إعادة تعيين كلمة المرور) ستبقى تعمل.</p>
          </>
        )}
        {status === "error" && (
          <>
            <div className="h-16 w-16 rounded-full bg-destructive/10 text-destructive grid place-items-center mx-auto">
              <XCircle className="h-8 w-8" />
            </div>
            <h1 className="text-xl sm:text-2xl font-display font-semibold">تعذر إلغاء الاشتراك</h1>
            <p className="text-muted-foreground">{msg || "الرابط غير صالح أو منتهي."}</p>
          </>
        )}
      </div>
    </div>
  );
}
